import wasSuperLikedProductSelector from 'modules/product/redux/selectors/was-super-liked-product'
import wasLikedProductSelector from 'modules/product/redux/selectors/was-liked-product'
import wasDislikedSampleSelector from 'modules/product/redux/selectors/was-disliked-sample'
import { createSelector } from 'reselect'
import isFullSizeVariantUtil from 'modules/variant/utils/is-full-size'

/**
 * @param {ProductVariantCollection} productVariant
 * @returns {(state) => ProductFrontend}
 */
const shouldShowFullSizeConversionVariantSelector = ({
  productVariant
}) => {
  const productId = productVariant?.product_id
  return createSelector(
    wasSuperLikedProductSelector(productId),
    wasLikedProductSelector(productId),
    wasDislikedSampleSelector(productId),
    (
      wasSuperLikedVariant,
      wasLikedVariant,
      wasDislikedVariant
    ) => {
      if (isFullSizeVariantUtil(productVariant)) {
        return false
      }

      return (
        wasSuperLikedVariant ||
        wasLikedVariant ||
        wasDislikedVariant
      )
    }
  )
}

export default shouldShowFullSizeConversionVariantSelector
